import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const ContactUs = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Contact Us" />
			<section className="contact-us">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 pe-5">
							<h2 class="main-heading-font dark-color level-2 text-start wow animate__animated animate__zoomIn mb-4">
								Lets Progress Together
							</h2>
							<form>
								<div className="row">
									<div className="form-group col-lg-6">
										<input
											type="text"
											className="form-control"
											id="firstName"
											placeholder=" First Name"
										/>
									</div>
									<div className="form-group col-lg-6">
										<input
											type="text"
											className="form-control"
											id="lastName"
											placeholder=" Last Name"
										/>
									</div>
								</div>
								<div className="form-group col-lg-12">
									<input
										type="email"
										className="form-control"
										id="email"
										placeholder="Enter email"
									/>
								</div>
								<div className="form-group col-lg-12">
									<input
										type="tel"
										className="form-control"
										id="phone"
										placeholder="Enter phone number"
									/>
								</div>
								<div className="form-group col-lg-12">
									<textarea
										className="form-control"
										id="message"
										rows="4"
										placeholder="Enter  Message"
									></textarea>
								</div>
								<Link
									class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
									to="/book-appointment"
								>
									<span class="bg-wrapper w-100">Submit</span>
								</Link>
							</form>
						</div>
						<div className="col-lg-6 mt-5 ps-4">
							<p class="primary-regular-font extra-color-5 level-7 mt-3">
								At Lane AW Health we have teams of professionals ready to assist
								you. You just have to find the option below that best fits your
								needs.
							</p>
							<div className="address-wrapper extra-bg-8 radius-20 p-4">
								<div className="main-address-detail d-flex align-items-center gap-4">
									<h4 className="secondary-bold-font level-7-lg mb-0">
										Address:
									</h4>
									<p className="mb-0">
										Sed ut perspiciatis unde omnis iste natus error sit volupta.
									</p>
								</div>
								<div className="main-address-detail mt-2 d-flex align-items-center gap-4">
									<h4 className="secondary-bold-font level-7-lg mb-0">
										Email:
									</h4>
									<p className="mb-0">Info.LaneAwHealth.com</p>
								</div>
								<div className="main-address-detail border-top mt-3 pt-3 d-flex align-items-center gap-4">
									<h4 className="secondary-bold-font level-7-lg mb-0">
										Availablity:
									</h4>
									<p className="mb-0">From Monday to Saturday: 9am - 9pm</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default ContactUs;
